import React from 'react';
import Icon from './Icon';
import { brands, heroStats } from '../data';

export default function Hero() {
  return (
    <section className="hero" id="home">
      <div
        className="hero__bg"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/banner.png)`,
        }}
      />
      <div className="hero__glow" />

      <div className="container hero__inner">
        <div className="hero__copy">
          <h1 className="hero__title">
            Building Intelligent
            <br />
            Celebration <span className="grad-text">Ecosystems</span>
          </h1>
          <span className="hero__rule" />
          <p className="hero__lead">
            At Caladium Systems, we combine emotion, technology and experience
            to transform the way the world celebrates.
          </p>
          <div className="hero__actions">
            <a href="#brands" className="btn btn--primary">
              Explore Our Ecosystem <Icon name="arrow-right" size={18} />
            </a>
            <a href="#founder" className="btn btn--ghost">
              <Icon name="play" size={15} /> Watch Our Vision
            </a>
          </div>
        </div>

        <div className="hero__visual">
          <div className="orbit">
            <span className="orbit__ring orbit__ring--1" />
            <span className="orbit__ring orbit__ring--2" />
            <div className="orbit__core">
              <img
                src={`${process.env.PUBLIC_URL}/images/Logo-caladium.png`}
                alt="Caladium Systems"
              />
            </div>
            {brands.map((b) => (
              <div
                key={b.id}
                className={`orbit__node orbit__node--${b.orbitPos}`}
                style={{ '--c': b.color }}
              >
                <div className="orbit__badge">
                  {b.logo ? (
                    <img src={b.logo} alt={b.name} />
                  ) : (
                    <span className="orbit__word">{b.name}</span>
                  )}
                </div>
                <span className="orbit__label">{b.orbitLabel}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="container">
        <div className="stats-bar">
          {heroStats.map((s) => (
            <div className="stat" key={s.label}>
              <span className="stat__icon">
                <Icon name={s.icon} size={22} />
              </span>
              <div className="stat__text">
                <span className="stat__top">
                  <strong className="stat__value">{s.value}</strong>
                  <span className="stat__label">{s.label}</span>
                </span>
                {s.sub && <span className="stat__sub">{s.sub}</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
